import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard CRM
import DashboardReducer from "./dashboard/reducer";

// Statistic
import StatisticReducer from "./statistic/reducer";

// Operator
import OperatorReducer from "./operator/reducer";

// User
import UserReducer from "./user/reducer";
import {
  UserRecruiterReducer,
  UserRecruiterVirtualReducer,
  UserJobSeekerReducer,
  UserJobSeekerVirtualReducer,
} from "./user/reducer";

// Role
import RoleReducer from "./role/reducer";

// Global
import GlobalReducer from "./global/reducer";

// User Admin
import AdminReducer from "./admin/reducer";

// Push Notification
import Notification from "./notification/reducer";

// Location Log
import EventLogReducer, { EventLogNewReducer } from "./eventLog/reducer";

import ReservationReducer from "./reservation/reducer";

import JobPostReducer from "./job-post/reducer";
import ApplicationReducer from "./application/reducer";
import PlanReducer from "./plans/reducer";
import UserPlanPurchaseReducer from "./user-plan-purchase/reducer";
import PushNotification from "./push-notification/reducer";
import ContentReducer, { AIContentApprovalReducer, AIContentTBEDReducer } from "./content/reducer";
import ResumeViewLogReducer from "./resume-view-log/reducer";
import AdultVerifyLogReducer from "./adult-verify-log/reducer";
import NoticeReducer from "./notice/reducer";
import AgencyReducer from "./agency/reducer";
import InquiryListReducer from "./inquiry-list/reducer";
import VOCReasonReducer from "./voc-reason/reducer";
import VOCListReducer from "./voc-list/reducer";
import CommentReducer from "./comment/reducer";
import TalentListReducer from "./talent/reducer";
import SectionReducer from "./section/reducer";
import BannerReducer from "./banner/reducer";
import BannerPositionReducer from "./banner-position/reducer";
import ContentTypeReducer from "./content-type/reducer";
import PopupReducer from "./popup/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: DashboardReducer,
  Statistic: StatisticReducer,
  User: UserReducer,

  UserRecruiter: UserRecruiterReducer,
  UserRecruiterVirtual: UserRecruiterVirtualReducer,
  UserJobSeeker: UserJobSeekerReducer,
  UserJobSeekerVirtual: UserJobSeekerVirtualReducer,

  JobPost: JobPostReducer,
  Agency: AgencyReducer,

  Plan: PlanReducer,
  UserPlanPurchase: UserPlanPurchaseReducer,

  PushNotification: PushNotification,

  Operator: OperatorReducer,

  Role: RoleReducer,
  Global: GlobalReducer,
  Admin: AdminReducer,

  Notification: Notification,

  EventLog: EventLogReducer,
  EventLogNew: EventLogNewReducer,

  Reservation: ReservationReducer,
  Application: ApplicationReducer,
  Notice: NoticeReducer,

  Content: ContentReducer,
  AIContentApproval: AIContentApprovalReducer,
  AIContentTBED: AIContentTBEDReducer,
  ContentType: ContentTypeReducer,

  ResumeViewLog: ResumeViewLogReducer,
  AdultVerifyLog: AdultVerifyLogReducer,

  InquiryList: InquiryListReducer,

  Comment: CommentReducer,

  VOCReasons: VOCReasonReducer,
  VOCList: VOCListReducer,

  TalentList: TalentListReducer,
  Section: SectionReducer,

  BannerPosition: BannerPositionReducer,
  Banner: BannerReducer,

  Popup: PopupReducer,
});

export default rootReducer;
